import { Intent, IToastProps, Toast, Toaster, ToasterPosition } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { DispatchProp } from 'modules/store'
import React, { Component } from 'react'
import { I18n } from 'react-i18next'
import { connect } from 'react-redux'

import * as fromActions from '../../../shared/store'
import * as fromStore from '../../../store'

import { i18nKeys } from 'app/app.i18n'
import { getToasts } from '../../../core/store'
import { isPresent, ToastPayload } from '../../../shared'

type OwnProps = {
  position: ToasterPosition
}

type StateProps = {
  toasts: ToastPayload[]
}

type Props = OwnProps & StateProps & DispatchProp

const mapStateToProps = (state: fromStore.State): StateProps => ({
  toasts: getToasts(state),
})

const DEFAULT_TIMEOUT_TO_DISSMISS = 3000 // in ms
const DEFAULT_TIMEOUT_TO_DISSMISS_WARNING = 7000 // in ms

const enhance = connect(mapStateToProps)

export class Toasterer extends Component<Props> {
  render() {
    const { position, toasts = [] } = this.props
    const defaultToastProps: Partial<IToastProps> = {
      intent: Intent.SUCCESS,
      icon: IconNames.SAVED,
      timeout: DEFAULT_TIMEOUT_TO_DISSMISS,
    }

    return (
      <I18n>
        {(t) => (
          <Toaster position={position}>
            {toasts.map((toast) => {
              const newProps = {
                ...defaultToastProps,
                ...toast,
                message: t(String(toast.message)),
                timeout:
                  isPresent(toast.intent) && toast.intent === Intent.DANGER
                    ? 0
                    : isPresent(toast.intent) && toast.intent === Intent.WARNING
                      ? DEFAULT_TIMEOUT_TO_DISSMISS_WARNING
                      : DEFAULT_TIMEOUT_TO_DISSMISS,
              }

              const toastContent = toast.message as any
              /**
               * 403 handling
               */
              if (isPresent(toastContent.response) && toastContent.response.status === 403) {
                return (
                  <Toast
                    key={`t-${toast.id}`}
                    {...newProps}
                    intent={Intent.WARNING}
                    icon={IconNames.WARNING_SIGN}
                    onDismiss={this.handleDissmiss(toast.id!)}
                    message={t(i18nKeys.auth.expiredLoginInfo)}
                    action={{
                      text: t(i18nKeys.auth.reloadApplication),
                      icon: IconNames.REFRESH,
                      onClick: () => window.location.reload(),
                    }}
                  />
                )
              }

              return <Toast key={`t-${toast.id}`} {...newProps} onDismiss={this.handleDissmiss(toast.id!)} />
            })}
          </Toaster>
        )}
      </I18n>
    )
  }
  private handleDissmiss = (id: string) => (didTimeoutExpire: boolean) => {
    this.props.dispatch(new fromActions.sharedActions.RemoveToastAction(id))
  }
}

export default enhance(Toasterer)



// WEBPACK FOOTER //
// ./src/app/shared/components/toasterer/toasterer.tsx